import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild
} from '@angular/core';
import {VexPopoverService} from '@vex/components/vex-popover/vex-popover.service';
import {
  ToolbarNotificationsDropdownComponent
} from './toolbar-notifications-dropdown/toolbar-notifications-dropdown.component';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatBadgeModule} from '@angular/material/badge';
import {FormsModule} from '@angular/forms';
import {AuthService} from '../../../../shared/services/auth.service';
import {NotifyService} from '../../../../shared/services/notify.service';
import {GlobalService} from '../../../../shared/services/global.service';
import {PusherService} from '../../../../shared/services/pusher.service';
import {SocketService} from '../../../../shared/services/socket.service';
import {NotificationService} from '../../../../shared/services/notification.service';
import Echo from 'laravel-echo';
import {ChatDataService} from '../../../../shared/services/chat-data.service';
import {GroupChatDataService} from '../../../../shared/services/group-chat-data.service';
import Pusher from 'pusher-js';

@Component({
  selector: 'vex-toolbar-notifications',
  templateUrl: './toolbar-notifications.component.html',
  styleUrls: ['./toolbar-notifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatBadgeModule,
    FormsModule
  ],
  providers: [
    AuthService,
    GlobalService,
    NotifyService,
  ]
})
export class ToolbarNotificationsComponent implements OnInit {
  @ViewChild('originRef', {static: true, read: ElementRef})
  originRef?: ElementRef;
  dropdownOpen: boolean = false;
  unreadNotification: number;
  user: any;

  private echo: Echo;
  window = {Pusher: null};
  userInteracted = false;

  constructor(
    private popover: VexPopoverService,
    private notifyService: NotifyService,
    private cdr: ChangeDetectorRef,
    private pusherService: PusherService,
    private authService: AuthService,
    private chatDataService: ChatDataService,
  ) {
    this.authService.self().subscribe((data) => {
      if (data && data.id) {
        this.user = data;
        // this.get();
      }
    });
    this.chatDataService.fromWebsocket$.subscribe((data) => {
   /*   console.log('Notifi Got from server: ', data);
      switch (data.type) {
        case 'GET_PRIVATE_MESSAGE':
         console.log('notification',data);
          break;

        default:
          console.warn('⚠️ Unknown event type:', data.type, data);
          break;
      }*/
    });
    }

  ngOnInit(): void {
    this.authService.self().subscribe((data) => {
      if (data) {
        this.user = data;
      }
    });
  }

  getChatNotificationsCount(){

  }

  showPopover(): void {
    this.dropdownOpen = true;
    this.cdr.markForCheck();

    if (!this.originRef) {
      throw new Error('originRef undefined!');
    }

    const popoverRef = this.popover.open({
      content: ToolbarNotificationsDropdownComponent,
      origin: this.originRef,
      offsetY: 12,
      position: [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top'
        }
      ]
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.dropdownOpen = false;
      this.cdr.markForCheck();
    });
  }
}
